module.exports = "<p>\n  workflow works!\n</p>\n"